module.exports = __webpack_public_path__ + "static/media/background.8174eed0.png";